import { useCallback, useMemo } from 'react';

const useSpecificRolesSelectorHandler = ({
  selectedRoles,
  onSelectedRolesChange
}) => {
  const selectedRoleIds = useMemo(
    () => new Set(selectedRoles.map(r => r.roleUri)),
    [selectedRoles]
  );

  const defaultRole = useMemo(() => selectedRoles.find(r => r.isDefault), [
    selectedRoles
  ]);

  const toggleRole = useCallback(
    ({ roleUri, displayText }) => {
      if (selectedRoleIds.has(roleUri)) {
        onSelectedRolesChange(selectedRoles.filter(r => r.roleUri !== roleUri));
      } else {
        onSelectedRolesChange([
          ...selectedRoles,
          { roleUri, isDefault: selectedRoles.length === 0, displayText }
        ]);
      }
    },
    [selectedRoles, selectedRoleIds, onSelectedRolesChange]
  );

  const setDefault = useCallback(
    roleUri => {
      onSelectedRolesChange(
        selectedRoles.map(r => ({ ...r, isDefault: r.roleUri === roleUri }))
      );
    },
    [selectedRoles, onSelectedRolesChange]
  );

  return {
    selectedRoleIds,
    defaultRoleUri: defaultRole?.roleUri ?? null,
    toggleRole,
    setDefault
  };
};

export default useSpecificRolesSelectorHandler;
